let VideoReplays = {
    filesCount: 0,
    invitesCount: 0,

    init: function () {
        this.bind();
    },

    bind: function () {
        this.form();
        this.delete();
    },

    delete: function () {
        $('.delete-video-replay').click(function () {
            let id = $(this).data('id');
            let row = $(this).closest('tr');

            swal({
                title: "Are you sure?",
                text: "Your will not be able to recover this record!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.value) {
                    $.post('/video-replays/' + id,
                        {
                            _method: 'delete'
                        },
                        (result) => {
                            if (result.success) {
                                let table = row.closest('table').DataTable();
                                table.row(row).remove().draw();
                                swal(
                                    'Deleted!',
                                    'Record has been deleted.',
                                    'success'
                                ).then((result) => {

                                });
                            }
                        });
                }
            });
        });
    },

    form: function () {
        let _this = this;
        const videoReplaysForm = $('#videoReplaysForm');
        const videoReplayInvitesForm = $('#videoReplayInvitesForm');
        const filesContainer = $('#files');
        const invitesContainer = $('#invites');
        _this.filesCount = $('.file').length;
        _this.invitesCount = $('.invite').length;

        if (videoReplaysForm.length) {
            let submitBtn = Ladda.create(videoReplaysForm.find('[type=submit]')[0]);

            videoReplaysForm.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        toastr.success(response.message);
                        setTimeout(() => {
                            window.location.assign('/video-replays/' + response.data.id + '/edit');
                        }, 1000);
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });

            $(document).on('click', '.add-file', function () {
                _this.filesCount++;

                let fileHtml = '<div class="file border-top pt-1">\n' +
                    '                            <div class="form-group">\n' +
                    '                                <label for="fileTitle' + _this.filesCount + '">Title</label>\n' +
                    '                                <input type="text" class="form-control" name="files[' + _this.filesCount + '][title]" id="trackTitle' + _this.filesCount + '" value="" placeholder="Title">\n' +
                    '                            </div>\n' +
                    '                            <div class="form-group">\n' +
                    '                                <label for="trackFile' + _this.filesCount + '">File</label>\n' +
                    '                                <input type="file" class="form-control" name="files[' + _this.filesCount + '][file]" id="trackFile' + _this.filesCount + '">\n' +
                    '                            </div>\n' +
                    '                            <div class="form-group">\n' +
                    '                                <button type="button" class="btn btn-danger remove-file">Remove</button>\n' +
                    '                            </div>\n' +
                    '                        </div>';

                filesContainer.append(fileHtml);
            });

            $(document).on('click', '.remove-file', function () {
                $(this).closest('.file').remove();
            });
        }

        if (videoReplayInvitesForm.length) {
            let submitBtn = Ladda.create(videoReplayInvitesForm.find('[type=submit]')[0]);

            videoReplayInvitesForm.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        toastr.success(response.message);
                        setTimeout(() => {
                            window.location.assign('/video-replays/' + response.data.id + '/edit');
                        }, 1000);
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });

            $(document).on('click', '.add-invite', function () {
                _this.invitesCount++;

                let inviteHtml = '<div class="file border-top pt-1 invite">\n' +
                    '                            <div class="form-group">\n' +
                    '                                <label for="inviteName' + _this.invitesCount + '">Name</label>\n' +
                    '                                <input type="text" class="form-control" name="emails[' + _this.invitesCount + '][name]" id="inviteName' + _this.invitesCount + '" value="" placeholder="Name">\n' +
                    '                            </div>\n' +
                    '                            <div class="form-group">\n' +
                    '                                <label for="inviteEmail' + _this.invitesCount + '">Email</label>\n' +
                    '                                <input type="text" class="form-control" name="emails[' + _this.invitesCount + '][email]" id="inviteEmail' + _this.invitesCount + '" value="" placeholder="Email">\n' +
                    '                            </div>\n' +
                    '                            <div class="form-group">\n' +
                    '                                <button type="button" class="btn btn-danger remove-invite">Remove</button>\n' +
                    '                            </div>\n' +
                    '                        </div>';

                invitesContainer.append(inviteHtml);
            });

            $(document).on('click', '.remove-invite', function () {
                $(this).closest('.invite').remove();
            });

            $(document).on('click', '.send-invite', function () {
                const _this = this;
                const id = $(_this).data('id');

                if ($('.send-invite').length) {
                    let submitBtnInvite = Ladda.create(this);

                    submitBtnInvite.start();
                    $.post('/video-replays/invite/' + id + '/send', {}, response => {
                        submitBtnInvite.stop();

                        if (response.success) {
                            toastr.success(response.message);
                            $(_this).text('Invitation Already Sent').prop('disabled', true);
                        } else {
                            toastr.error(response.message);
                        }
                    })
                }

            });
        }

        $('#videoReplays').on('draw.dt', function () {
            _this.delete();
        });
    },
};

let currentPublicValue = 0;
function handlePublicClick(val) {
    currentPublicValue = val;
    if(currentPublicValue == 0) {
        document.getElementById('replayLink').style.display = 'none';
    }else{
        document.getElementById('replayLink').style.display = 'block';
    }
}

$().ready(function () {
    window.VideoReplays = VideoReplays;
    window.VideoReplays.init();
    
    $("input[name='public']").click(
        function(){
            var radioValue = $("input[name='public']:checked").val();
            if(radioValue){
                handlePublicClick(radioValue);
            }
        }
    );
});